import { useRef, useState } from "react";

//components
import { IconButton, IconLibrary } from "thrive-components";
import { AddedByDefaultActionButton } from "../ActionButtons";

//helpers
import { extractFullFeedSources, getSourceListTooltipSettings } from "@/helpers/CombinedFeed";
import { useClickAwayClose } from "@/components/hooks/utility/useClickAwayClose";

const maxListItems = 3;

const AddedByDefaultActions = ({content, isAlteringContentItem, isRefreshingFeed, onOpenListClick}: {content: any, isAlteringContentItem :boolean, isRefreshingFeed: boolean, onOpenListClick:(listId: number, title: string)=>void}) => {
    const dropdownRef = useRef<HTMLElement | null>(null);
    const [displaySourceListInfo, setDisplaySourceListInfo] = useState<boolean>(false);
    const listData : any[] = extractFullFeedSources(content.feedSources);
    const { extraDetailText } = getSourceListTooltipSettings(listData, maxListItems);

    useClickAwayClose( displaySourceListInfo, dropdownRef, () => {setDisplaySourceListInfo(false)});
    return (
        <>
        <span className="source-lists-actions">
            <IconButton 
                parentRef={dropdownRef}
                key={`${content.id}-dropdown-information-button`}
                ariaLabel={'View parents which have been selected as source lists'} 
                iconName={IconLibrary.ALERT_INFO} 
                className={`source-list-information-content-button ${isAlteringContentItem || isRefreshingFeed  ? "source-list-information-content-button-loading" : ""}`} 
                onButtonClick={() => setDisplaySourceListInfo(!displaySourceListInfo)}
            />
                            
            <AddedByDefaultActionButton
                isAlteringContentItem={isAlteringContentItem}
                isRefreshingFeed={isRefreshingFeed}
            />

            <IconButton 
                key={`${content.id}-traverse-content`}
                ariaLabel={'Open list content'} 
                iconName={IconLibrary.CHEVRON_RIGHT} 
                className={`open-list-content-button`} 
                onButtonClick={() => onOpenListClick(content.id, content.title)} 
            />
        </span>

        <span className={`source-lists-actions ${displaySourceListInfo ? "open-source-lists-actions" : "closed-source-lists-actions"}`}>
            <ul className="source-list-dropdown-list">
                <li className="source-list-item more-items">
                    <span className="remaining-details">Added from:</span>
                </li>

                {listData.slice(0, maxListItems).map((item, index) => (
                    <li key={index} className="source-list-item">
                        {item.displayIcon && (
                            <div className="icon-wrapper">{item.icon}</div>
                        )}

                        <div className="details">
                            <span className="title">{item.title}</span>
                            <span className="subtitle">{item.subtitle}</span>
                        </div>
                    </li>
                ))}

                {extraDetailText && (
                    <li className="source-list-item more-items">
                        <span className="remaining-details">
                            {extraDetailText}
                        </span>
                    </li>
                )}
            </ul>
        </span>
        </>
    );  
}

export default AddedByDefaultActions;